angular.module('BillPay')
    .controller('PaymentContactCtrl', function ($scope, Payment) {

        $scope.emailAddress = Payment.emailAddress;

        $scope.setContactInfo = function (emailAddress) {
            if ($scope.forms.contactForm.$invalid) return;
            var goodToGo = false;

            if ($scope.isEcashiering && !emailAddress) {
                //Skip validation and clear out email
                Payment.emailAddress = '';
                goodToGo = true;
            } else {
                goodToGo = Payment.set('emailAddress', emailAddress);
            }

            if (goodToGo) {
                $scope.continue();
            }
        };
    });
